import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { useTranslation } from "@/i18n/translations";

export default function DeleteAccountLink({ API }) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);

  const run = async () => {
    setBusy(true);
    try {
      await axios.delete(`${API}/account`, { data: { confirm: text } });
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      toast.success(t("settings.deleteDone"));
      setTimeout(() => { window.location.href = "/"; }, 1200);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Error");
      setBusy(false);
    }
  };

  return (
    <div className="mt-10 pt-4 border-t border-gray-100 text-center" data-testid="delete-account-block">
      {!open ? (
        <button type="button" data-testid="delete-account-link" onClick={() => setOpen(true)}
          className="text-[11px] text-gray-400 hover:text-red-600 underline underline-offset-2 transition-colors">
          {t("settings.deleteAccount")}
        </button>
      ) : (
        <div className="max-w-md mx-auto text-left border-2 border-red-300 bg-red-50 rounded-xl p-4">
          <div className="font-bold text-red-700 text-sm">{t("settings.deleteAccount")}</div>
          <p className="text-xs text-gray-700 mt-1">{t("settings.deleteWarn")}</p>
          <p className="text-xs text-gray-700 mt-2">{t("settings.deleteTypeHint")}</p>
          <input data-testid="delete-account-confirm-input" value={text} onChange={(e) => setText(e.target.value)}
            placeholder="DELETE" className="mt-2 w-full border-2 border-red-300 rounded-lg px-3 py-2 text-sm bg-white outline-none focus:border-red-600" />
          <div className="flex gap-2 mt-3">
            <button type="button" data-testid="delete-account-confirm-btn" disabled={busy || text.trim().toUpperCase() !== "DELETE"} onClick={run}
              className="flex-1 bg-red-600 text-white text-sm font-semibold rounded-lg py-2 disabled:opacity-40">
              {busy ? "…" : t("settings.deleteConfirmBtn")}
            </button>
            <button type="button" data-testid="delete-account-cancel-btn" onClick={() => { setOpen(false); setText(""); }}
              className="flex-1 border-2 border-gray-300 text-sm rounded-lg py-2 bg-white">
              {t("settings.deleteCancel")}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
